module.exports = __webpack_public_path__ + "media/images/guide/image3-f9be00f8dfbdf9fe4071be575e922d63.png";